module.exports = __webpack_public_path__ + "static/media/icon_better@3x.1bc11c6c.png";